import { render, staticRenderFns } from "./edit-mark.vue?vue&type=template&id=29236982&scoped=true&"
import script from "./edit-mark.vue?vue&type=script&lang=ts&"
export * from "./edit-mark.vue?vue&type=script&lang=ts&"
import style0 from "./edit-mark.vue?vue&type=style&index=0&id=29236982&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29236982",
  null
  
)

export default component.exports